import {Box, Link, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import CustomModal from '../CustomModal';

export const VirtualMeetingRoomLink = ({link, roomNumber, begin, end}) => {
    const gracePeriodInMilliseconds = 60 * 60 * 1000;
    const linkActiveBegin =  new Date(begin.getTime() - gracePeriodInMilliseconds);
    const linkActiveEnd = new Date(end.getTime() + gracePeriodInMilliseconds);
    const dateTimeFormatter = new Intl.DateTimeFormat('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
    const timeFormatter = new Intl.DateTimeFormat('de-DE', {
        hour: '2-digit',
        minute: '2-digit',
    });
    const [denialType, setDenialType] = useState(null);

    const handleLinkClick = (event) => {
        const now = new Date();

        if (now < linkActiveBegin || now > linkActiveEnd) {
            event.preventDefault();
            setDenialType(now < linkActiveBegin ? 'before' : 'after');
        }
    };

    const resetDenialType = () => {
        setDenialType(null);
    };

    const isLinkActiveDateBeforeToday = (new Date()).setHours(0, 0, 0, 0) < (new Date(linkActiveBegin.getTime())).setHours(0, 0, 0, 0);

    return <>
        <Link href={link} onClick={handleLinkClick} target="_blank" underline="always" color="#083163" style={{whiteSpace: 'nowrap'}} rel="noopener noreferrer">
            Virtueller Lernraum {roomNumber}
        </Link>
        <CustomModal open={null !== denialType} title={'Virtueller Lernraum nicht verfügbar'} onClose={resetDenialType} maxWidth={'sm'}>
            {denialType === 'before' && <>
                <Typography>Der virtuelle Lernraum ist erst ab {isLinkActiveDateBeforeToday ? dateTimeFormatter.format(linkActiveBegin) : timeFormatter.format(linkActiveBegin)} Uhr verfügbar.</Typography>
                <Typography mt={1}>Falls Sie sich vorab mit der Technik vertraut machen oder die Einstellungen überprüfen möchten, stehen unsere virtuellen Testräume für Sie zur Verfügung.</Typography>
            </>}
            {denialType === 'after' && <>
                <Typography>Dieser Link zum virtuellen Lernraum ist nicht mehr gültig, da die Veranstaltung bereits abgeschlossen ist.</Typography>
                <Typography mt={1}>Möchten Sie sich mit der Technik vertraut machen oder die Einstellungen überprüfen, stehen unsere virtuellen Testräume für Sie zur Verfügung.</Typography>
            </>}
            <Box mt={2} display={'flex'} flexDirection={'column'} gap={1}>
                <Typography><Link href={'https://lernwelt.drv-bund.de/goto.php?target=xmvc_25741&client_id=weiterbildung'} target={'_blank'} underline={'always'}>Zum Testraum für Teilnehmende</Link></Typography>
                <Typography><Link href={'https://lernwelt.drv-bund.de/goto.php?target=xmvc_32542&client_id=weiterbildung'} target={'_blank'} underline={'always'}>Zum Testraum für Moderierende und Dozierende</Link></Typography>
            </Box>
        </CustomModal>
    </>;
};

VirtualMeetingRoomLink.propTypes = {
    link: PropTypes.string.isRequired,
    roomNumber: PropTypes.string.isRequired,
    begin: PropTypes.instanceOf(Date).isRequired,
    end: PropTypes.instanceOf(Date).isRequired,
};
